import React from "react";
import numeral from "numeral";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
const styles = StyleSheet.create({
  page: {
    // backgroundColor: '#ffffff',
    // marginRight: 50,
    // paddingBottom: 60,
    // marginTop: 60,
    // paddingLeft: 50,
  },
  body: {
    paddingTop: 30,
    paddingLeft: 30,
  },

  row: {
    width: "50%",
  },
  title: {
    fontSize: 10,
    // fontWeight: 600,
    color: "#1D1C1A",
    // Font: "helvetica",
  },
  total: {
    fontSize: 11,
    fontWeight: 1000,
    color: "#1D1C1A",
    Font: "helvetica",
  },
  subtitle: {
    fontSize: 9,
    // fontWeight: 400,
    width:250,
    color: "#1D1C1A",
    // Font: "helvetica",
  },
  package: {
    Font: "helvetica",
    // fontWeight: 400,
    fontSize: 9,
  
  },
  packageBold: {
    // Font: "helvetica",
    fontWeight: 900,
    fontSize: 9,
  
  },
});

export function TurnOverReports({
  pkgSalesItem,
  drSalesItem,
  pkgTurnOverDate,
  pkgTotal,
  drTurnOverDate,
  drTotal,
  printby,
  datePrinted,
  total,
  mergedItems,
  drPaymentTotal
}) {
  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.body}>
        <View style={{ marginVertical: 10 }}>
          <Text style={styles.title}>Turn Over Report (Summary)</Text>
          <Text style={styles.subtitle}>Date Range: {pkgTurnOverDate}</Text>
          <Text style={styles.subtitle}>
            Printed By/Date: {printby} &nbsp;&nbsp;
            {datePrinted}
          </Text>
        </View>
        <View style={{ marginVertical: 10 }}>
          <Text style={styles.title}>Package Sales</Text>
        </View>
        {pkgSalesItem.map((data, index) => (
          <View style={styles.row} key={index}>
            <View
              style={{ justifyContent: "space-between", flexDirection: "row" }}
            >
              <View>
                <Text style={[styles.package,{width:90}]}>{data.type}</Text>
              </View>
              <View>
                <Text style={[styles.package,{textAlign:'right',width:180}]}>
                  {numeral(data.amount).format("0,0.00")}
                </Text>
              </View>
            </View>
          </View>
        ))}
        <View style={styles.row}>
          <View
            style={{ justifyContent: "space-between", flexDirection: "row" }}
          >
            <Text style={[styles.total]}>Package Sales Total:</Text>
            <Text style={styles.total}>
              {numeral(pkgTotal).format("0,0.00")}
            </Text>
          </View>
        </View>
      </Page>
      <Page size="A4" orientation="portrait" style={styles.body}>
        <View style={{ marginVertical: 10 }}>
          <Text style={styles.title}>Turn Over Report (Summary)</Text>
          <Text style={styles.subtitle}>Date Range: {drTurnOverDate}</Text>
          <Text style={styles.subtitle}>
            Printed By/Date: {printby} &nbsp;&nbsp; 
            {datePrinted}
          </Text>
        </View>
        <View style={{ marginVertical: 10 }}>
          <Text style={styles.title}>Direct Sales</Text>
        </View>
        {drSalesItem.map((data, index) => (
          <View style={styles.row} key={index}>
            <View
              style={{ justifyContent: "space-between", flexDirection: "row" }}
            >
              <View>
                <Text style={[styles.package,{width:90}]}>{data.type}</Text>
              </View>
              <View>
                <Text style={[styles.package,{textAlign:'right',width:180}]}>
                  {numeral(data.amount).format("0,0.00")}
                </Text>
              </View>
            </View>
          </View>
        ))}
        <View style={styles.row}>
          <View
            style={{ justifyContent: "space-between", flexDirection: "row" }}
          >
            <Text style={styles.total}>Direct Sales Total:</Text>
            <Text style={styles.total}>
              {numeral(drPaymentTotal).format("0,0.00")}
            </Text>
          </View>
        </View>
      </Page>
      <Page size="A4" orientation="portrait" style={styles.body}>
        <View style={{ marginVertical: 10 }}>
          <Text style={styles.title}>Turn Over Report (Summary)</Text>
          <Text style={styles.subtitle}>Date Range: {pkgTurnOverDate}</Text>
          <Text style={styles.subtitle}>
            Printed By/Date: {printby} &nbsp;&nbsp;
            {datePrinted}
          </Text>
        </View>
        <View style={styles.row}>
          <View
            style={{ justifyContent: "space-between", flexDirection: "row" }}
          >
            <Text style={styles.title}>Type</Text>
            <Text style={styles.title}>Amount</Text>
          </View>
        </View>
        {/* {pkgSalesItem.map((data, index) => (
          <View style={styles.row} key={index}>
            <View
              style={{ justifyContent: "space-between", flexDirection: "row" }}
            >
              <View>
                <Text style={[styles.package,{width:90}]}>{data.type}</Text>
              </View>
              <View>
                <Text style={[styles.package,{textAlign:'right',width:180}]}>
                  {numeral(data.amount).format("0,0.00")}
                </Text>
              </View>
            </View>
          </View>
        ))} */}
                {mergedItems.map((data1, index) => (
          <View style={styles.row} key={index}>
            <View
              style={{ justifyContent: "space-between", flexDirection: "row" }}
            >
              <View>
                <Text style={[styles.package,{width:90}]}>{data1.type}</Text>
              </View>
              <View>
                <Text style={[styles.package,{textAlign:'right',width:180}]}>
                  {numeral(data1.amount).format("0,0.00")}
                </Text>
              </View>
            </View>
          </View>
        ))}
        <View style={styles.row}>
          <View
            style={{ justifyContent: "space-between", flexDirection: "row" }}
          >
            <Text style={[styles.total,{fontWeight:'bold'}]}>Total Turn Over:</Text>
            <Text style={styles.total}>
              {numeral(total).format("0,0.00")}
            </Text>
          </View>
        </View>
        <View style={{width:'100%'}}>
                <Text style={[styles.package,{marginVertical:10}]}>Check By:___________________________________ Date:_____________</Text>
                <Text style={[styles.package]}>Noted By:___________________________________ Date:_____________</Text>
        </View>
      </Page>
    </Document>
  );
}
